<template>
  <div>
    <cadastro-base
      :salvar="salvarServico"
      :is-modal="isCadastroModal"
    >
      <template slot="conteudo">
        <b-row>
          <b-form-group
            class="col-12 my-0 pb-0"
          >
            <b-form-checkbox
              ref="servicoAtivo"
              v-model="form.ativo"
              checked="true"
              class="custom-control-primary"
              style="float:right"
              name="check-button"
              switch
              @change="verificaVinculo"
            >
              <label style="font-size: 1rem">Serviço ativo</label>
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group
            label="Nome"
            class="col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Nome"
            >
              <b-form-input
                v-model="form.nome"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- <b-form-group
            :label="'Tipo'"
            class="col-md-4"
          >
            <b-select
              v-model="form.tipo"
              @change="atualizaParticipaRodizio"
            >
              <option :value="null" />
              <option
                v-for="(opcao, $index) in tipoOpcoes"
                :key="$index"
                :value="opcao.value"
              >{{ opcao.text }}</option>
            </b-select>
          </b-form-group> -->

          <b-col cols="3">
            <departamento-select
              v-model="form.departamento"
              require
            />
          </b-col>

          <b-col cols="3">
            <b-form-group label="Periodicidade">
              <b-select
                v-model="form.periodicidade"
                :required="true"
                @change="onChangePeriodicidade"
              >
                <option
                  v-for="(opcao, $index) in periodicidadeOpcoes"
                  :key="$index"
                  :value="opcao.value"
                >{{ opcao.text }}</option>
              </b-select>
            </b-form-group>
          </b-col>

          <!-- <b-col cols="2">
            <legend
              tabindex="-1"
              class="bv-no-focus-ring col-form-label pt-0"
            >&nbsp;</legend>
            <b-form-checkbox
              v-model="form.utilizarNaChecklist"
              value="true"
              unchecked-value="false"
              style="margin-top: 0.7rem; float:right"
            >
              Utilizar no checklist
            </b-form-checkbox>
          </b-col> -->
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group>
              <tipo-tributacao-select
                :value="form.tributacoes"
                :multiple="true"
                :require="false"
                :disabled="form.periodicidade != 'recorrente' || form.honorarioContabil"
                @input="inputTributacao"
              />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group>
              <tipo-atividade-select
                :value="form.atividades"
                :multiple="true"
                :require="haTributacao"
                :disabled="!haTributacao"
                @input="inputAtividade"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row
          class="mb-1"
          style="margin-top: -1rem;"
        >
          <b-col cols="6">
            <div style="display: flex;">
              <div>
                <legend style="font-size: 14px;">
                  ID Omie do Simples Nacional
                </legend>
              </div>
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  title="Selecione nesse campo qual serviço da Omie de tributação do Simples Nacional corresponde a esse cadastro!"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
            <b-input-group>
              <b-input
                ref="inputIdOmieSimlesNacional"
                v-model="nomeCodigoServicoSimplesOmie"
                v-b-tooltip.hover
                :title="form.nomeCodigoServicoSimplesOmie"
                disabled
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  style="float:right"
                  @click="abrirSelecaoOmie(true)"
                >
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col cols="6">
            <div style="display: flex;">
              <div>
                <legend style="font-size: 14px;">
                  ID Omie de outras tributações
                </legend>
              </div>
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  title="Selecione nesse campo qual serviço da Omie de tributação diferente do Simples Nacional corresponde a esse cadastro!"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
            <b-input-group>
              <b-input
                ref="inputIdOmie"
                v-model="nomeCodigoServicoOutrasTributacoesOmie"
                v-b-tooltip.hover
                :title="form.nomeCodigoServicoOutrasTributacoesOmie"
                disabled
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  style="float:right"
                  @click="abrirSelecaoOmie(false)"
                >
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col cols="6">
            <b-row>
              <b-col cols="4">
                <b-form-checkbox
                  v-model="form.participaRodizioEquipe"
                >
                  Rodízio equipe
                </b-form-checkbox>
              </b-col>

              <b-col
                cols="3"
                class="p-0"
              >
                <b-form-checkbox
                  v-model="form.osConstituicao"
                  @change="updateIntegrarManualmente"
                >
                  O.S constituição
                </b-form-checkbox>
              </b-col>

              <b-col cols="5">
                <b-form-checkbox
                  v-model="form.integrarManualOmie"
                  :disabled="form.osConstituicao"
                >
                  Integrar manualmente O.S (Omie)
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col
                cols="2"
                class="ml-auto"
              >
                <b-form-checkbox
                  v-model="form.matriz"
                  :disabled="(!form.tributacoes || form.tributacoes.length === 0) || (!form.atividades || form.atividades.length === 0)"
                >
                  Matriz
                </b-form-checkbox>
              </b-col>

              <b-col cols="4">
                <b-form-checkbox
                  v-model="form.honorarioContabil"
                  :disabled="form.periodicidade === 'naorecorrente'"
                  @change="onChangeHonorario"
                >
                  <div style="position:relative !important;">
                    Listar pacote de honorários
                    <i
                      v-b-tooltip.hover
                      title="Os serviços que estiverem com esse parâmetro marcado, serão sugeridos no pacote do tipo honorários. Os serviços cadastrados sem essa marcação, serão sugeridos no pacote do tipo serviços."
                      style="font-size: 0.65rem;"
                    >
                      <font-awesome-icon
                        :icon="faQuestionCircle"
                      />
                    </i>
                  </div>
                </b-form-checkbox>
              </b-col>

              <b-col cols="6">
                <b-form-checkbox
                  v-model="form.substituirItens"
                  :disabled="!form.honorarioContabil"
                >
                  Substituir itens checklist
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>

        </b-row>

        <divisoria-descricao
          :titulo="'Integração G-Click'"
          :descricao="'Selecione o processo que o serviço tem relação na G-Click'"
        />
        <b-row>
          <b-col cols="6">
            <div class="d-flex flex-row align-items-center justify-content-between">
              <gclick-departamento-select
                ref="gClickdepartamentoSelect"
                class="flex-grow-1"
                v-model="form.gClickDepartamento"
              />
              <b-button
                v-if="form.gClickDepartamento"
                variant="primary"
                class="flex-shrink-0 mt-1"
                @click="limparGClickDepartamento"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </b-col>

          <b-col cols="6">
            <div class="d-flex flex-row align-items-center justify-content-between">
              <gclick-processo-select
                ref="gClickProcessoSelect"
                class="flex-grow-1"
                :key="form.gClickDepartamento ? form.gClickDepartamento.id : null"
                v-model="form.gClickProcesso"
                :disabled="!form.gClickDepartamento"
                :departamento-id="form.gClickDepartamento ? form.gClickDepartamento.id : null"
              />
              <b-button
                v-if="form.gClickProcesso"
                variant="primary"
                class="flex-shrink-0 mt-1"
                @click="limparGClickProcesso"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </b-col>

          <b-col cols="6">
            <div class="d-flex flex-row align-items-center justify-content-between">
              <gclick-fluxo-select
                ref="gClickFluxoSelect"
                class="flex-grow-1"
                :key="form.gClickDepartamento ? form.gClickDepartamento.id : null"
                v-model="form.gClickFluxo"
                :disabled="!form.gClickDepartamento"
                :departamento-id="form.gClickDepartamento ? form.gClickDepartamento.id : null"
              />
              <b-button
                v-if="form.gClickFluxo"
                variant="primary"
                class="flex-shrink-0 mt-1"
                @click="limparGClickFluxo"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </b-col>
        </b-row>

        <divisoria-descricao
          :titulo="'Valores atuais do serviço'"
          :descricao="'Valores do serviço baseados na competência atual'"
        />
        <b-row>
          <b-form-group class="col-md-3">
            <dinheiro-input
              v-model="form.valorRCC"
              :label="'Valor RCC'"
              require
              :disabled="$route.path.indexOf('editar') > 0"
              :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
            />
          </b-form-group>
          <b-form-group class="col-md-3">
            <dinheiro-input
              v-model="form.valorAuditar"
              :label="'Valor Auditar'"
              require
              :disabled="$route.path.indexOf('editar') > 0"
              :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
            />
          </b-form-group>
          <b-form-group
            v-if="$route.path.indexOf('editar') > 0"
            class="col-md-6"
          >
            <reajuste-modal
              v-model="form.reajuste"
              style="padding-top:1.9rem"
              :servico-id="form.id"
            />
          </b-form-group>
        </b-row>

        <b-row>
          <div
            style="display: flex;"
            class="col-md-12"
          >
            <div>
              <legend style="font-size: 14px;">
                Complemento (Visível para o cliente)
              </legend>
            </div>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                title="Atenção: essa descrição ficará visível para o cliente nos e-mails de notificações!"
                style="font-size: 0.65rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
          <b-form-group
            class="col-md-12"
          >
            <b-form-input
              v-model="form.descricao"
            />
          </b-form-group>
        </b-row>
      </template>
    </cadastro-base>
    <servicos-omie
      ref="servicoOmieModal"
      :id-omie="form.servicoOutrasTributacoesIdOmie"
      :simples-nacional="false"
      @selecionado="servicoSelecionado"
    />
    <servicos-omie
      ref="servicoSimplesOmieModal"
      :id-omie="form.servicoSimplesIdOmie"
      :simples-nacional="true"
      @selecionado="servicoSimplesSelecionado"
    />
  </div>
</template>

<style lang="scss">
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import moment from 'moment'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comuns/servico/shared/services/api'

export default {
  name: 'Servico',
  components: {
    CadastroBase,
    ValidationProvider,
    FontAwesomeIcon,
    DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    ReajusteModal: () => import('../reajuste-modal/ReajusteModal.vue'),
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    TipoTributacaoSelect: () => import('@/shared/components/tipo-tributacao-select/TipoTributacaoSelect.vue'),
    TipoAtividadeSelect: () => import('@/shared/components/tipo-atividade-select/TipoAtividadeSelect.vue'),
    ServicosOmie: () => import('../servicos-omie/ServicosOmie.vue'),
    GclickProcessoSelect: () => import('@/shared/components/gclick-form-fields/gclick-processo-select.vue'),
    GclickDepartamentoSelect: () => import('@/shared/components/gclick-form-fields/gclick-departamento-select.vue'),
    GclickFluxoSelect: () => import('@/shared/components/gclick-form-fields/gclick-fluxo-select.vue'),
  },
  props: {
    isCadastroModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      faQuestionCircle,
      form: {
        id: 0,
        nome: '',
        descricao: '',
        participaRodizioEquipe: false,
        ativo: true,
        tipo: null,
        utilizarNaChecklist: false,
        departamento: null,
        valorRCC: 0,
        valorAuditar: 0,
        periodicidade: 'recorrente',
        honorarioContabil: false,
        substituirItens: false,
        tributacoes: [],
        atividades: [],
        matriz: false,
        servicoIdOmie: null,
        osConstituicao: false,
        integrarManualOmie: false,
        gClickDepartamento: null,
        gClickProcesso: null,
        gClickFluxo: null,
        reajuste: {
          tipoAumento: 'valorcheio',
          valorRCC: 0,
          valorAuditar: 0,
          competencia: moment(moment(), 'YYYY/MM'),
        },
      },
      immutableForm: {},
      tipoOpcoes: [
        { value: 'constituicaomatriz', text: 'Constituição - Matriz' },
        { value: 'constituicaofilial', text: 'Constituição - Filial' },
        { value: 'transferenciamatriz', text: 'Transferência - Matriz' },
        { value: 'transferenciafilial', text: 'Transferência - Filial' },
      ],
      periodicidadeOpcoes: [
        { value: 'recorrente', text: 'Recorrente' },
        { value: 'naorecorrente', text: 'Não recorrente' },
      ],
      haTributacao: false,
      nomeCodigoServicoOutrasTributacoesOmie: null,
      nomeCodigoServicoSimplesOmie: null,
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getServico(id)
        .then(payload => {
          const servico = payload.data

          // Atualize cada propriedade individualmente
          Object.keys(this.form).forEach(key => {
            // Se a propriedade existir no serviço, atualize, senão mantenha o valor atual
            this.form[key] = servico[key] !== undefined ? servico[key] : this.form[key]
          })
          // this.form = servico
          this.form.gClickDepartamento = servico.departamentoGClick
          this.form.gClickProcesso = servico.processoGClick
          this.form.gClickFluxo = servico.fluxoGClick
          this.montaTextoServico(servico.nomeCodigoServicoOutrasTributacoesOmie, false)
          this.montaTextoServico(servico.nomeCodigoServicoSimplesOmie, true)
          this.haTributacao = servico.tributacoes.length > 0
        })
    },
    salvarServico() {
      return new Promise((resolve, reject) => {
        const payload = {
          ...this.form,
          DepartamentoGClickId: this.form.gClickDepartamento ? parseInt(this.form.gClickDepartamento.id, 10) : null,
          ProcessoGClickId: this.form.gClickProcesso ? parseInt(this.form.gClickProcesso.id, 10) : null,
          FluxoGClickId: this.form.gClickFluxo ? parseInt(this.form.gClickFluxo.id, 10) : null,
        }
        if (this.state === 'novo') {
          api.createServico(payload)
            .then(() => {
              this.$router.go(-1)
              resolve('Serviço cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          if (this.form.reajuste) {
            this.removeCaracteresValores()
          }
          api.updateServico(this.form.id, payload)
            .then(() => {
              this.$router.go(-1)
              resolve('Serviço alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    cancelar() {
      this.$router.go(-1)
    },
    atualizaParticipaRodizio() {
      this.form.participaRodizioEquipe = this.form.tipo !== null
    },
    removeCaracteresValores() {
      this.form.reajuste.valorRCC = parseFloat(this.form.reajuste.valorRCC, 10)
      this.form.reajuste.valorAuditar = parseFloat(this.form.reajuste.valorAuditar, 10)
    },
    onChangePeriodicidade(valor) {
      if (valor === 'naorecorrente') {
        this.form.honorarioContabil = false
        this.form.substituirItens = false
        this.form.tributacoes = []
        this.form.atividades = []
        this.form.matriz = false
        this.haTributacao = false
      }
    },
    onChangeHonorario(checked) {
      if (!checked) {
        this.form.substituirItens = false
      } else {
        this.form.tributacoes = []
        this.form.atividades = []
        this.form.matriz = false
        this.haTributacao = false
      }
    },
    inputTributacao(valor) {
      this.form.tributacoes = valor
      this.haTributacao = valor.length > 0
      if (!this.haTributacao) {
        this.form.atividades = []
        this.form.matriz = false
      }
    },
    inputAtividade(valor) {
      this.form.atividades = valor
      this.form.matriz = valor.length > 0 && this.form.matriz
    },
    verificaVinculo(checked) {
      if (!checked && this.form.id > 0) {
        api.existeVinculoPacoteAtivo(this.form.id)
          .then(payload => {
            if (payload.data) {
              this.$swal({
                text: 'Atenção: Ao realizar essa ação, também será desvinculado esse serviço dos pacotes. Consequentemente, os valores dos pacotes serão afetados. Deseja continuar?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-danger ml-1',
                },
              })
                .then(result => {
                  if (!result.value) {
                    this.form.ativo = !checked
                  }
                })
            }
          })
      }
    },
    abrirSelecaoOmie(value) {
      if (value) {
        this.$refs.servicoSimplesOmieModal.show()
      } else {
        this.$refs.servicoOmieModal.show()
      }
    },
    servicoSelecionado(value) {
      if (value.check) {
        this.$set(this.form, 'servicoOutrasTributacoesIdOmie', value.intListar.nCodServ)
        this.montaTextoServico(`${value.cabecalho.cCodigo} - ${value.cabecalho.cDescricao}`, false)
      } else {
        this.$set(this.form, 'servicoOutrasTributacoesIdOmie', null)
        this.$set(this.form, 'nomeCodigoServicoOutrasTributacoesOmie', null)
        this.nomeCodigoServicoOutrasTributacoesOmie = null
      }
    },
    servicoSimplesSelecionado(value) {
      if (value.check) {
        this.$set(this.form, 'servicoSimplesIdOmie', value.intListar.nCodServ)
        this.montaTextoServico(`${value.cabecalho.cCodigo} - ${value.cabecalho.cDescricao}`, true)
      } else {
        this.$set(this.form, 'servicoSimplesIdOmie', null)
        this.$set(this.form, 'nomeCodigoServicoSimplesOmie', null)
        this.nomeCodigoServicoSimplesOmie = null
      }
    },
    montaTextoServico(texto, simples = false) {
      if (texto) {
        const element = this.$refs.inputIdOmie.$el.offsetWidth
        const limit = Math.trunc(element / 10)
        if (simples) {
          this.nomeCodigoServicoSimplesOmie = texto.length > limit ? `${texto.substring(0, limit)}...` : texto
          this.$set(this.form, 'nomeCodigoServicoSimplesOmie', texto)
        } else {
          this.nomeCodigoServicoOutrasTributacoesOmie = texto.length > limit ? `${texto.substring(0, limit)}...` : texto
          this.$set(this.form, 'nomeCodigoServicoOutrasTributacoesOmie', texto)
        }
      }
    },
    updateIntegrarManualmente() {
      this.form.integrarManualOmie = this.form.osConstituicao
    },
    limparGClickProcesso() {
      this.$refs.gClickProcessoSelect.limpar()
      this.form.gClickProcesso = null
    },
    limparGClickFluxo() {
      this.$refs.gClickFluxoSelect.limpar()
      this.form.gClickFluxo = null
    },
    limparGClickDepartamento() {
      this.$refs.gClickdepartamentoSelect.limpar()
      this.form.gClickDepartamento = null
      this.limparGClickProcesso()
      this.limparGClickFluxo()
    },
  },
  watch: {
    'form.gClickDepartamento': function formGClickDepartamentoWatcher(newValue) {
      if (newValue && this.form.gClickProcesso && this.form.gClickDepartamento.id !== this.form.gClickProcesso.departamento.id) {
        this.form.gClickProcesso = null
      }
    },
  },
}
</script>
